import { gql, TypedDocumentNode } from "@apollo/client";

import {
  QuerySearchBlueprintVersionedGroupsArgs,
  QuerySearchBlueprintVersionedGroupsSuggestionsArgs,
  SearchSuggestionsOutput,
  SearchBlueprintVersionedGroupsOutput,
  MutationBlueprintVersionedGroupDeleteArgs,
  MutationBlueprintVersionedGroupCreateArgs,
  MutationBlueprintVersionedGroupUpdateArgs,
  BlueprintVersionedGroup,
} from "types/generated";

type SearchBlueprintVersionedGroupsData = {
  searchBlueprintVersionedGroups: SearchBlueprintVersionedGroupsOutput;
};

export const SEARCH_BLUEPRINT_VERSIONED_GROUPS: TypedDocumentNode<
  SearchBlueprintVersionedGroupsData,
  QuerySearchBlueprintVersionedGroupsArgs
> = gql`
  query SearchBlueprintVersionedGroups($input: SearchInput!) {
    searchBlueprintVersionedGroups(input: $input) {
      edges {
        cursor
        node {
          canDelete
          createdAt
          description
          deploymentsCount
          id
          labels
          latestVersion {
            id
            version
          }
          name
          space {
            id
            name
            accessLevel
          }
          ulid
          updatedAt
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

type SearchBlueprintVersionedGroupsSuggestionsData = {
  searchBlueprintVersionedGroupsSuggestions: SearchSuggestionsOutput;
};

export const SEARCH_BLUEPRINT_VERSIONED_GROUPS_SUGGESTIONS: TypedDocumentNode<
  SearchBlueprintVersionedGroupsSuggestionsData,
  QuerySearchBlueprintVersionedGroupsSuggestionsArgs
> = gql`
  query SearchBlueprintVersionedGroupsSuggestions($input: SearchSuggestionsInput!) {
    searchBlueprintVersionedGroupsSuggestions(input: $input) {
      filteredCount
      fields {
        name
        orderable
        filterable
        type
        possibleValuesBoolean {
          values
          counts
        }
        possibleValuesEnum {
          values
          counts
        }
        possibleValuesString {
          values
          counts
        }
        possibleValuesHierarchy {
          values {
            id
            parentId
            displayValue
          }
          counts
        }
      }
    }
  }
`;

type DeleteBlueprintGroupData = {
  blueprintVersionedGroupDelete: Pick<BlueprintVersionedGroup, "id" | "name">;
};

export const DELETE_BLUEPRINT_GROUP: TypedDocumentNode<
  DeleteBlueprintGroupData,
  MutationBlueprintVersionedGroupDeleteArgs
> = gql`
  mutation BlueprintGroupDelete($id: ID!) {
    blueprintVersionedGroupDelete(id: $id) {
      id
      name
    }
  }
`;

type CreateBlueprintGroupData = {
  blueprintVersionedGroupCreate: Pick<BlueprintVersionedGroup, "id" | "name">;
};

export const CREATE_BLUEPRINT_GROUP: TypedDocumentNode<
  CreateBlueprintGroupData,
  MutationBlueprintVersionedGroupCreateArgs
> = gql`
  mutation BlueprintGroupCreate($input: BlueprintVersionedGroupCreateInput!) {
    blueprintVersionedGroupCreate(input: $input) {
      id
      name
    }
  }
`;

type UpdateBlueprintGroupData = {
  blueprintVersionedGroupUpdate: Pick<
    BlueprintVersionedGroup,
    "id" | "name" | "description" | "createdAt" | "space" | "labels"
  >;
};

export const UPDATE_BLUEPRINT_GROUP: TypedDocumentNode<
  UpdateBlueprintGroupData,
  MutationBlueprintVersionedGroupUpdateArgs
> = gql`
  mutation UpdateBlueprintGroup($id: ID!, $input: BlueprintVersionedGroupUpdateInput!) {
    blueprintVersionedGroupUpdate(id: $id, input: $input) {
      id
      name
      description
      createdAt
      space {
        id
        name
        accessLevel
      }
      labels
    }
  }
`;
